import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { AppMultiSelect, AppSingleSelect } from '@/layout/AppComponents';
import { axiosPath } from '../../../../routing/helpers/router';
import errorHandler from '@/layout/components/error/ErrorHandler';
import useIsMounted from '../../hooks/useIsMounted';

export default function TotalEnergiesRiskRiskSelect({
  value,
  error,
  onHandleChange,
  className = '',
  title,
  isMulti = false,
  hasSearchBox = false,
  hasSelectOptions = false,
  isClearable = false,
  required = false,
  filterHex = undefined,
}) {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [risks, setRisks] = useState();

  // > LOAD RISKS //
  const loadRisks = useCallback(
    async () =>
      axios
        .post(
          axiosPath('api_r_user_module_totalEnergiesRisk_getRisks'),
          { moduleBridgeHex, filterHex }
        )
        .then(({ data }) => {
          if (isMounted.current) setRisks(data);
        })
        .catch((e) => dispatch(errorHandler(e))),

    [moduleBridgeHex, filterHex]
  );

  useEffect(() => {
    loadRisks();
  }, []);
  // < LOAD RISKS //

  return isMulti ? (
    <AppMultiSelect
      options={risks}
      title={title || 'Riesgos principales'}
      placeholder="Selecciona uno o varios riesgos"
      value={value}
      onChange={onHandleChange}
      error={error}
      allowSelectAll
      className={className}
      isLoading={!risks}
      hasSearchBox={hasSearchBox}
      hasSelectOptions={hasSelectOptions}
      required={required}
    />
  ) : (
    <AppSingleSelect
      options={risks}
      title={title || 'Riesgo principal'}
      placeholder="Selecciona un riesgo"
      value={value}
      onChange={onHandleChange}
      isLoading={!risks}
      error={error}
      hasSearchBox
      hasSelectOptions={hasSelectOptions}
      isClearable={isClearable}
      required={required}
    />
  );
}
